// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-menu-button[data-v-0fbbaf9a]{all:unset;display:flex;align-items:center;height:100%;padding:0 15px;font-size:16px}.login-menu-button.logged-in[data-v-0fbbaf9a]{color:var(--jw-color-primary)}", ""]);
// Exports
module.exports = exports;
